module.exports = __webpack_public_path__ + "img/0006.2ac8510e.jpg";